import CityPageTemplate from './CityPageTemplate';

export default function LongwoodPage() {
  return (
    <CityPageTemplate
      city="Longwood"
      county="Seminole"
      slug="longwood"
      zipCodes={['32750', '32779']}
      neighborhoods={['Historic Longwood District', 'Wekiva Springs area', 'Springs Landing', 'Sabal Point', 'Markham Woods corridor']}
      localContext="Longwood sits in the heart of Seminole County with a charming historic district and established neighborhoods along the Wekiva Springs and Markham Woods corridors."
      metaDescription="Professional residential and commercial cleaning services in Longwood, FL. Serving ZIP codes 32750 & 32779. We Bring the Boom to Every Room. Call SOTSVC today!"
    />
  );
}
